import React from 'react';
import { observer } from 'mobx-react';
import ImageDisplay from './ImageDisplay';

function CompanyAppearanceLogoDisplay({ logo, onRemoveLogo }) {
    const src =
        import.meta.env.REACT_APP_RESOURCES_URL +
        '/' +
        import.meta.env.REACT_APP_COMPANY_RESOURCES_DIR +
        '/' +
        logo;

    return (
        <ImageDisplay
            src={src}
            alt="Your logo"
            onRemove={onRemoveLogo}
            maxWidth="280px"
            maxHeight="200px"
        />
    );
}

export default observer(CompanyAppearanceLogoDisplay);
